// extracted by mini-css-extract-plugin
module.exports = {"wishlist-section":"WishlistPage_wishlist-section__2AoXR","wishlist-empty":"WishlistPage_wishlist-empty__2CgUc"};